import get from "lodash/get";
import { getTheme } from "../../api/requests";
import { logoutHandle } from "../user/actions";

export const GET_THEME = "GET_THEME";

export const fetchTheme = () => async (dispatch) => {
  try {
    const { data } = await getTheme();

    dispatch({ type: GET_THEME, payload: { ...data } });
  } catch (e) {
    if ([401, 422].includes(get(e, "response.status"))) {
      logoutHandle(dispatch);
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/theme/actions.js